import axios from "axios";
import config from "../../config/config.json";
import {useEffect, useState} from "react";
import {process} from "@progress/kendo-data-query";
import {Grid, GridToolbar} from "@progress/kendo-react-grid";
import {GridColumn as Column} from "@progress/kendo-react-grid/dist/npm/GridColumn";
import DurationEditor from "../editComponents/DurationEditor";

const InvoiceRecapGrid = props => {

    const includeNoNB = props.includeNoNB
    const period = props.period

    //debugger

    const projectIDs = props.projectIDs.filter(item => item.checked).map(item => item.id).join(',');

    const selected = {"projects": projectIDs, "includeInvoiced": props.includeInvoiced.id, "nonBillable": includeNoNB.id, "period": period.id, }

    const [data, setData] = useState()

    useEffect(() => {
        getData()
    }, []);

    async function getData() {
        try {
            console.log("before data set")
            const response = await axios.post(config.API_URL + 'invoice/get_items_for_invoice_recap', selected, {headers: {'x-api-key': sessionStorage.getItem("apiKEY")}});
            const newData = response.data
            const newData2 = newData.map(item => ({...item, Date: new Date(item.Date)}))
            setData(newData2);
            console.log("data set")
        } catch (error) {
            //set({ error: error.message, isLoading: false });
            console.log("data set error", error)
        }
    }


    const initialDataState = {
        // take: 1000,
        skip: 0,
        // pageSize:10,
        take:10,
        sort:[
            {dir: "desc", field: "Date" }
        ],
    };

    const [dataState, setDataState] = useState(initialDataState);

    // ************************************** GRID *************************************


    // const [page, setPage] = useState(initialDataState);
    const [pageSizeValue, setPageSizeValue] = useState(10);

    const pageChange = (event) => {

        const targetEvent = event.syntheticEvent;
        const take = targetEvent.value === "All" ? process(data, dataState).length : event.page.take;

        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }

        setDataState({
            ...dataState,
            skip: event.page.skip,
            take: event.page.take
        });
    };

    return(
        <>

            {data && <>

                <Grid
                    //pageable={true}
                    sortable={true}
                    filterable={true}
                    //scrollable={"virtual"} //virtual, scrollable
                    resizable={true}
                    reorderable={true}
                    rowHeight={45}
                    // onItemChange={itemChange}

                    editField="inEdit"
                    //pageable={true}


                    style={{
                        height: "100%", //"calc(100% - 55px)", // (refSize.height - 150) / 2,//"500px",
                        minHeight: 700,
                        maxHeight: 700, // refSize.height - 70,
                        width: "100%" //refSize.width - menuSize,
                    }}
                    data={process(data, dataState)}{...dataState}

                    // data={process(data, dataState).slice(page.skip, page.take + page.skip)}{...dataState}
                    // skip={page.skip}
                    // take={page.take}
                    total={process(data, dataState).length}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [10, 50, 100, 500],
                        pageSizeValue: pageSizeValue,
                    }}
                    onPageChange={pageChange}

                    //onPageChange={pageChange}
                    onDataStateChange={(e) => setDataState(e.dataState)}

                    // onRowDoubleClick={rowDblClick}

                >



                    <Column field="ID" title="ID" width="80px" filterable={true} editable={false} />

                    {/*<Column cell={myID} field="ID" title="ID" width="80px" footerCell={myFooterCell} filterable={true}/>*/}
                    {/*<Column cell={myID} field="ID" title="ID" width="80px" filterable={true} locked/>*/}
                    {/*<Column field="ProjectID" minResizableWidth={120} title="Projekt" width={300} locked*/}
                    {/*        cell={useProjectEditor} filterCell={ProjectFilter} footerCell={CountFooter} />*/}
                    {/*<Column field="AuthorID" minResizableWidth={120} title="Autor" cell={useAuthorEditor}*/}
                    {/*        filterCell={AuthorFilter} width={150} editable={true} locked />*/}


                    <Column field="Type" minResizableWidth={120} title="Typ" width={150}/>
                    <Column field="ItemType" minResizableWidth={120} title="Typ" width={150}/>
                    <Column field="Date" minResizableWidth={100} title="Datum" width={150}
                            filter="date"
                            format="{0:dd.MM.yyyy}"
                            editor="date"
                        //cell={DateCell}
                        //     filterCell={useDateFilter}
                    />

                    <Column field="Text" minResizableWidth={120} title="Text" width={150}/>
                    <Column field="AuthorShort" minResizableWidth={120} title="Autor" width={150}/>
                    <Column field="ProjectName" minResizableWidth={120} title="Project" width={150}/>
                    <Column field="TimeSpent" minResizableWidth={120} title="Hodin" width={150}/>
                    <Column field="Price" minResizableWidth={120} title="Cena" width={150}/>
                    <Column field="Currency" minResizableWidth={120} title="Mena" width={150}/>


                </Grid>

            </>}

        </>
    )
}

export default InvoiceRecapGrid